import { useLang } from "../i18n";

const Row = ({ items }) => (
  <div className="flex shrink-0 items-center">
    {items.map((item, i) => (
      <span key={i} className="flex items-center">
        <span
          className={`font-display uppercase tracking-wider text-5xl sm:text-7xl px-6 ${
            i % 2 === 0 ? "text-outline" : "text-red-600"
          }`}
        >
          {item}
        </span>
        <span className="text-zinc-700 font-display text-4xl sm:text-5xl">+</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => {
  const { t } = useLang();
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-zinc-800 bg-[#0A0A0C] py-6 sm:py-8 select-none">
      <div className="marquee-track flex w-max">
        <Row items={t.marquee} />
        <Row items={t.marquee} />
      </div>
    </div>
  );
};
